import { extractPictures } from "./picturesExtractor";
import { InstrumentationLabels } from "../constants/Instrumentation";
import { extractInstrumentationTypeTree } from "./instrumentationTypesExtractor";
import { extractPrimaryValue } from "./valuesExtractor";
import SpecificationKeys from "../constants/SpecificationKeys";
import { mapBlockDistance, mapSensitivity } from "../utils/specificationUtils";

function specHasValue(specs: $TSFixMe, key: string, value: string = "true") {
  return specs[key] && specs[key].value === value;
}

function getSpecValue(specs: $TSFixMe, key: string) {
  return specs[key] && specs[key].value;
}

export function extractInstrumentation(rawInstrumentation: $TSFixMe) {
  const instrumentation = {
    id: rawInstrumentation.id,
    tag: rawInstrumentation.tag,
    statusName: rawInstrumentation.status
      ? rawInstrumentation.status.name
      : null,
    statusCode: rawInstrumentation.status
      ? rawInstrumentation.status.code
      : null,
    worstStatusName: rawInstrumentation.worst_asset_status
      ? rawInstrumentation.worst_asset_status.name
      : null,
    worstStatusCode: rawInstrumentation.worst_asset_status
      ? rawInstrumentation.worst_asset_status.code
      : null,
    typeName: rawInstrumentation.type ? rawInstrumentation.type.name : null,
    typeCode: rawInstrumentation.type ? rawInstrumentation.type.code : null,
    type: rawInstrumentation.type
      ? extractInstrumentationTypeTree(rawInstrumentation.type)
      : null,
    criticality: rawInstrumentation.criticality,
    accessibility: rawInstrumentation.accessibility,
    description: rawInstrumentation.description,
    pictures: rawInstrumentation.pictures
      ? extractPictures(rawInstrumentation)
      : null,
    tenantId: rawInstrumentation.tenant ? rawInstrumentation.tenant.id : null,
    tenantName: rawInstrumentation.tenant
      ? rawInstrumentation.tenant.name
      : null,
    tenantPublic: rawInstrumentation.tenant
      ? rawInstrumentation.tenant.public
      : null,
    itemType: "instrumentation",
    value: extractPrimaryValue(rawInstrumentation.values, false),
    specifications: rawInstrumentation.specifications,
    nodes: rawInstrumentation.nodes?.items,
  };
  const specs = rawInstrumentation.specifications;

  (instrumentation as $TSFixMe).criticalityQuality = undefined;
  (instrumentation as $TSFixMe).criticalityEnvironment = undefined;
  (instrumentation as $TSFixMe).criticalitySafety = undefined;
  (instrumentation as $TSFixMe).specialDemands = undefined;
  (instrumentation as $TSFixMe).environmentalCondition = undefined;
  (instrumentation as $TSFixMe).unit = undefined;
  (instrumentation as $TSFixMe).empty = undefined;
  (instrumentation as $TSFixMe).full = undefined;
  (instrumentation as $TSFixMe).blockDistance = undefined;
  (instrumentation as $TSFixMe).sensitivity = undefined;
  (instrumentation as $TSFixMe).mediumType = undefined;

  if (specs) {
    (instrumentation as $TSFixMe).criticalityQuality = specHasValue(
      specs,
      InstrumentationLabels.CRITICALITY_QUALITY,
    );
    (instrumentation as $TSFixMe).criticalityEnvironment = specHasValue(
      specs,
      InstrumentationLabels.CRITICALITY_ENVIRONMENT,
    );
    (instrumentation as $TSFixMe).criticalitySafety = specHasValue(
      specs,
      InstrumentationLabels.CRITICALITY_SAFETY,
    );
    (instrumentation as $TSFixMe).specialDemands = specHasValue(
      specs,
      InstrumentationLabels.SPECIAL_DEMANDS,
    );
    (instrumentation as $TSFixMe).environmentalCondition = specHasValue(
      specs,
      InstrumentationLabels.ENVIRONMENTAL_CONDITION,
      "heavy",
    );

    (instrumentation as $TSFixMe).unit = getSpecValue(
      specs,
      SpecificationKeys.FullEmptyConfiguration.UNIT,
    );

    (instrumentation as $TSFixMe).unit = getSpecValue(
      specs,
      SpecificationKeys.FullEmptyConfiguration.UNIT,
    );

    (instrumentation as $TSFixMe).empty = getSpecValue(
      specs,
      SpecificationKeys.FullEmptyConfiguration.EMPTY,
    );
    (instrumentation as $TSFixMe).full =
      specs[SpecificationKeys.FullEmptyConfiguration.FULL] &&
      specs[SpecificationKeys.FullEmptyConfiguration.FULL].value;
    const blockDistanceSpec =
      specs[SpecificationKeys.FullEmptyConfiguration.BLOCK_DISTANCE];
    (instrumentation as $TSFixMe).blockDistance =
      mapBlockDistance(blockDistanceSpec);
    const sensitivitySpec =
      specs[SpecificationKeys.FullEmptyConfiguration.SENSITIVITY];
    (instrumentation as $TSFixMe).sensitivity = mapSensitivity(sensitivitySpec);
    (instrumentation as $TSFixMe).mediumType =
      specs[SpecificationKeys.GeneralSettings.MEDIUM_TYPE] &&
      specs[SpecificationKeys.GeneralSettings.MEDIUM_TYPE].value;
  }
  return instrumentation;
}

export function extractInstrumentations(rawInstrumentations: $TSFixMe) {
  if (!rawInstrumentations) {
    return [];
  }
  if (rawInstrumentations.items) {
    return rawInstrumentations.items.map((instrumentation: $TSFixMe) =>
      extractInstrumentation(instrumentation),
    );
  }
  return rawInstrumentations.instrumentations.map((instrumentation: $TSFixMe) =>
    extractInstrumentation(instrumentation),
  );
}
